import request from '@/utils/request';
import { TIME_OUT } from '@/utils/mappingDict';

/*
* 种粮大户补贴
* */

// 补贴申报通知-列表
export function getDeclarationNoticeList(data) {
  return request({
    url: '/grain/grower/user/list',
    method: 'POST',
    data: { ...data, status: 1 },
  });
}

// 补贴申报通知-详情
export function getDeclarationNoticeDetail(id) {
  return request({
    url: '/grain/grower/detail',
    method: 'GET',
    params: { id },
  });
}

// 补贴申报通知-申请
export function addApply(data) {
  return request({
    url: '/grain/grower/application/add',
    method: 'POST',
    data,
  });
}

// 补贴申报通知-获取申报主体基本信息
export function getBasicInfo(applicationYear) {
  return request({
    url: '/grain/grower/application/basicinfo',
    method: 'GET',
    params: { applicationYear },
  });
}

// 民族地区
export function getMinorityArea() {
  return request({
    url: '/grain/grower/application/minority/area',
    method: 'GET',
  });
}

// 根据市、区县获取种粮地点乡镇列表
export function getGrowerTownList(cityCode, areaCode) {
  return request({
    url: '/grain/grower/application/region/town',
    method: 'GET',
    params: { cityCode, areaCode },
  });
}

// 根据乡镇获取种粮地点村列表
export function getGrowerVillageList(townCode) {
  return request({
    url: '/grain/grower/application/region/village',
    method: 'GET',
    params: { townCode },
  });
}

// 我的申请-详情
export function getGrainGrowerApplyDetail(id) {
  return request({
    url: '/grain/grower/application/detail',
    method: 'GET',
    params: { id, type: 1 },
  });
}

// 报表下载
export function fileDownload(id) {
  return request({
    url: '/grain/grower/application/export',
    method: 'GET',
    responseType: 'blob',
    params: { id },
    timeout: TIME_OUT,
  });
}

// 公示列表查询
export function getPublicList(data) {
  return request({
    url: '/grain/grower/manage/user/release/publish',
    method: 'POST',
    data: { ...data },
  });
}
